import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class CmaReportsService {
  authToken: any;
  user: any;
  baseURI: any;

  constructor(private http: HttpClient, private auth: AuthService) {
    this.baseURI = this.auth.baseURL;
  }

  loadToken() {
    const token = localStorage.getItem('bUser_token');
    this.authToken = token;
    const user = localStorage.getItem('user');
    this.user = user;
  }

  cmaTatReport(params = {}) {
    // let headers: HttpHeaders = new HttpHeaders();
    // this.loadToken();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    // return this.http.post(
    //   this.baseURI + `reports/loan/loan-application-by-cma`,
    //   params,
    //   { headers: headers }
    // );

    return this.http.get(this.baseURI + `reports/cma/tat`, {
      // headers: headers,
      params,
    });
  }

  getLoanAppforCMAWithStatus(params = {}) {
    // let headers: HttpHeaders = new HttpHeaders();
    // this.loadToken();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    return this.http.get(this.baseURI + `reports/cma/loan-application-cma`, {
      // headers: headers,
      params,
    });
  }

  // getLoanAppforCMAWithStatusforReports(status) {
  //   let headers: HttpHeaders = new HttpHeaders();
  //   this.loadToken();
  //   headers = headers.append('Authorization', this.authToken);
  //   headers = headers.append('Content-Type', 'application/json');
  //   return this.http.get(this.baseURI + `reports/cma/loan-application-cma/${status}`, { headers: headers });
  // }

  getSiteVisited(params) {
    // let headers: HttpHeaders = new HttpHeaders();
    // this.loadToken();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    return this.http.get(this.baseURI + 'reports/cma/cma-visited', {
      // headers: headers,
      params,
    });
  }

  getSiteVisitPending(params) {
    // let headers: HttpHeaders = new HttpHeaders();
    // this.loadToken();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    return this.http.get(this.baseURI + 'reports/cma/not-visited', {
      // headers: headers,
      params,
    });
  }
}
